import Big from "big.js";
import { GameFont } from "by/gamefactory/cityversetycoon/scenes/common/GameFont";
import { RayLightContainer } from "by/gamefactory/cityversetycoon/scenes/common/components/RayLightContainer/RayLightContainer";
import { CubeTexturePack } from "by/gamefactory/cityversetycoon/scenes/common/components/animations/texturesPacks/CubeTexturePack";
import { FixResult } from "by/gamefactory/cityversetycoon/scenes/common/models/Building/upgrade/FixResult";
import { UpgradeResult } from "by/gamefactory/cityversetycoon/scenes/common/models/Building/upgrade/UpgradeResult";
import { IPlayerModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IPlayerModel";
import { SoundsResourcePackageWrapper } from "by/gamefactory/cityversetycoon/scenes/common/resources/SoundsResourcePackageWrapper";
import { FadeScreen } from "by/gamefactory/cityversetycoon/scenes/game/components/FadeScreen";
import { FullscreenInputBlocker } from "by/gamefactory/cityversetycoon/scenes/game/components/FullscreenInputBlocker";
import { InputBlocker } from "by/gamefactory/cityversetycoon/scenes/game/components/InputBlocker";
import { TickerDelay } from "by/gamefactory/tools/TickerDelay";
import { gsap } from "gsap";
import { Graphics, IDestroyOptions, Point, Rectangle, Sprite, Text, TextStyle } from "pixi.js";
import { IAnalyticProviderWrapper } from "../../../../../../analytics/IAnalyticProviderWrapper";
import { VirtualScreenEvent } from "../../../../../../analytics/events/VirtualScreenEvent";
import { ICanvasScaler } from "../../../../../../canvas/ICanvasScaler";
import { StringFormatExtention } from "../../../../../../extensions/StringFormatExtention";
import { PromiseCompletionSource } from "../../../../../../shared/async/PromiseCompletionSource";
import { nameof } from "../../../../../../shared/bindable-data";
import { ILogger } from "../../../../../logger/ILogger";
import { BasePageView } from "../../../../common/components/BasePageView";
import { DefaultButton } from "../../../../common/components/DefaultButton";
import { FullBuildingTooltip } from "../../../../common/components/FullBuildingTooltip";
import { CoinsCollectAnimationView } from "../../../../common/components/animations/CoinsCollectAnimationView";
import { HBox } from "../../../../common/components/ui/HBox";
import { IFirstTimeExperienceController } from "../../../../common/controller/IFirstTimeExperienceController";
import { IBuildingModel } from "../../../../common/models/Building/IBuildingModel";
import { IUpgradeBuildingModel } from "../../../../common/models/Building/upgrade/IUpgradeBuildingModel";
import { CommonResourcesPackage } from "../../../../common/resources/CommonResourcesPackage";
import { TopPanel } from "../../../../game/components/toppanel/TopPanel";
import { IGameController } from "../../../../game/controllers/IGameController";
import { PiggyAnimationPromiseHolder } from "../../../buildingUpgradeItem/components/PiggyAnimationPromiseHolder";
import { Building } from "../../components/Building";
import { BuildingItem } from "../../components/BuildingItem";
import { CubeExplowAnimationView } from "../../components/CubeExplowAnimationView";
import { LoyaltyCoinsContainer } from "../../components/LoyaltyCoinsContainer";
import { OutOfCoinsPanel } from "../../components/OutOfCoinsPanel";
import { UpgradeCircleScroll } from "../../components/UpgradeCircleScroll";
import { UpgradePanel } from "../../components/UpgradePanel";
import { UpgradeTutorial } from "../../components/tutorial/UpgradeTutorial";
import { UpgradeTutorialForToken } from "../../components/tutorial/UpgradeTutorialForToken";
import { IMyBuildingsController } from "../../controller/IMyBuildingsController";
import { MyBuildingsTutorialResourcePackage } from "../../resources/MyBuildingsTutorialResourcePackage";
import { UpgradeResourcePackage } from "../../resources/UpgradeResourcePackage";
import { VariableSaver } from "by/gamefactory/tools/variableSaver/VariableSaver";
import { DynamicResourcesPackage } from "../../../../../../resources/DynamicResourcesPackage";
import { CancellationToken } from "async/CancellationToken";
import { IGuestModel } from "by/gamefactory/cityversetycoon/scenes/common/models/IGuestModel";
import { IFirstTimeExperienceModel } from "../../../../common/models/IFirstTimeExperienceModel";
import { ButtonWithScaleAnimation } from "../../../../common/components/ButtonWithScaleAnimation";

export class MyBuildingUpgradePage extends BasePageView {
    private readonly cancellationToken: CancellationToken;
    private readonly commonResources: CommonResourcesPackage;
    private readonly upgradeResources: UpgradeResourcePackage;
    private readonly myBuildingsDynamicResources: DynamicResourcesPackage;
    private readonly myBuildingController: IMyBuildingsController;
    private readonly gameController: IGameController;
    private readonly pageCompletionSource: PromiseCompletionSource<void>;
    private readonly tutorialResources: MyBuildingsTutorialResourcePackage;
    private readonly buildingModel: IBuildingModel;
    private readonly building: Building;
    private readonly itemsListeners: Array<() => void>;
    private readonly logger: ILogger;
    private readonly analyticsProvider: IAnalyticProviderWrapper;
    private readonly topPanel: TopPanel;
    private readonly soundResources: SoundsResourcePackageWrapper;
    private readonly playerModel: IPlayerModel;
    private readonly firstTimeExperienceController: IFirstTimeExperienceController;
    private readonly firstTimeExperienceModel: IFirstTimeExperienceModel;
    private readonly myBuildingsPcs: PromiseCompletionSource<boolean>;
    private readonly piggyAnimationPcs: PiggyAnimationPromiseHolder;
    private readonly variableSaver: VariableSaver;
    private readonly guestModel: IGuestModel;

    private backButton: DefaultButton;
    private backToLobbyButton: ButtonWithScaleAnimation;
    private circleScroll: UpgradeCircleScroll;
    private upgradePanel: UpgradePanel;
    private loyaltyCoinsContainer: LoyaltyCoinsContainer;
    private bottomLight: Sprite;
    private transitionTimeLine: gsap.core.Timeline;
    private upgradeItems: BuildingItem[];
    private selectedItemIndex: number;
    private upgradeTutorial: UpgradeTutorial;
    private inputBlocker: InputBlocker;
    private tutorialInputBlocker: InputBlocker;
    private tokenTutorial?: UpgradeTutorialForToken;
    private fadeScreen: FadeScreen;
    private coinsSubtractPoint: Point;
    private tokensSubtractPoint: Point;
    private coinsSubtractAnimation: CoinsCollectAnimationView;
    private tokensSubtractAnimation: CoinsCollectAnimationView;
    private isFirstShow: boolean;
    private neededTokenTutorial: boolean;
    private fakeBuildingItem: BuildingItem;
    private upgradeCompletionSource: PromiseCompletionSource<void>;
    private buildingLevelUpCompletionSource: PromiseCompletionSource<void>;
    private hideFlag = false;
    private piggyTooltipInfo: FullBuildingTooltip;

    public constructor(
        cancellationToken: CancellationToken,
        commonResources: CommonResourcesPackage,
        upgradeResources: UpgradeResourcePackage,
        myBuildingsDynamicResources: DynamicResourcesPackage,
        pageCompletionSource: PromiseCompletionSource<void>,
        canvasScaler: ICanvasScaler,
        buildingModel: IBuildingModel,
        myBuildingController: IMyBuildingsController,
        gameController: IGameController,
        building: Building,
        logger: ILogger,
        analyticsProvider: IAnalyticProviderWrapper,
        topPanel: TopPanel,
        soundResources: SoundsResourcePackageWrapper,
        playerModel: IPlayerModel,
        isFirstShow: boolean,
        firstTimeExperienceController: IFirstTimeExperienceController,
        firstTimeExperienceModel: IFirstTimeExperienceModel,
        myBuildingsPcs: PromiseCompletionSource<boolean>,
        neededTokenTutorial: boolean,
        piggyAnimationPcs: PiggyAnimationPromiseHolder,
        variableSaver: VariableSaver,
        guestModel: IGuestModel,
        tutorialResources?: MyBuildingsTutorialResourcePackage
    ) {
        super(canvasScaler);
        this.cancellationToken = cancellationToken;
        this.commonResources = commonResources;
        this.upgradeResources = upgradeResources;
        this.myBuildingsDynamicResources = myBuildingsDynamicResources;
        this.pageCompletionSource = pageCompletionSource;
        this.buildingModel = buildingModel;
        this.myBuildingController = myBuildingController;
        this.gameController = gameController;
        this.building = building;
        this.isFirstShow = isFirstShow;
        this.tutorialResources = tutorialResources;
        this.logger = logger;
        this.analyticsProvider = analyticsProvider;
        this.topPanel = topPanel;
        this.soundResources = soundResources;
        this.playerModel = playerModel;
        this.firstTimeExperienceController = firstTimeExperienceController;
        this.firstTimeExperienceModel = firstTimeExperienceModel;
        this.myBuildingsPcs = myBuildingsPcs;
        this.neededTokenTutorial = neededTokenTutorial;
        this.piggyAnimationPcs = piggyAnimationPcs;
        this.variableSaver = variableSaver;
        this.guestModel = guestModel;
        this.itemsListeners = [];
        this.upgradeItems = [];
        this.selectedItemIndex = 0;
        this.buildingModel.propertyChanged.add(this.onBuildingModelPropertyChanged, this);
        this.build();
        this.once("added", this.show, this);
    }

    private async onBuildingModelPropertyChanged(model: IBuildingModel, key: string): Promise<void> {
        switch (key) {
            case nameof(model, "piggyMultiplier"):
                this.loyaltyCoinsContainer.updateMultiplier(model.piggyMultiplier.value);
                this.loyaltyCoinsContainer.visible = model.piggyMultiplier.value != 1;
                break;
            case nameof(model, "buildingLevelUpModel"):
                const buildingRankUpModel = this.buildingModel.buildingLevelUpModel.value;
                if (buildingRankUpModel != undefined) {
                    this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Building Level up", this.analyticsProvider.currentEventIndex));
                    await this.upgradeCompletionSource?.result;
                    this.buildingLevelUpCompletionSource = new PromiseCompletionSource<void>();
                    const piggyAnimationPromise = this.piggyAnimationPcs.promise;
                    if (piggyAnimationPromise != null) {
                        await piggyAnimationPromise;
                    }
                    const topPanelOnNotification = this.topPanel.onNotificationLayer;
                    this.topPanel.bringToOriginParent();
                    await this.myBuildingController.showBuildingRankUpPopup(buildingRankUpModel, this.buildingModel, this.cancellationToken);
                    if (topPanelOnNotification) {
                        this.topPanel.bringToFront();
                    }
                    if (buildingRankUpModel.level >= 3) {
                        this.building.listIn.setLocked(false);
                    }
                    this.buildingLevelUpCompletionSource.complete();
                }
                break;
            case nameof(model, "userLevelUpModel"):
                const userLevelModel = this.buildingModel.userLevelUpModel.value;
                if (userLevelModel != undefined) {
                    const fullscreenInputBlocker = new FullscreenInputBlocker(this.canvasScaler);
                    this.addChild(fullscreenInputBlocker);
                    this.topPanel.interactiveChildren = false;
                    this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Player level up", this.analyticsProvider.currentEventIndex));
                    await this.upgradeCompletionSource?.result;
                    await this.buildingLevelUpCompletionSource?.result;
                    await this.myBuildingController.showUserProfilePopup(userLevelModel);
                    this.removeChild(fullscreenInputBlocker);
                    if (userLevelModel.openedPiggyBank != null) {
                        this.buildingModel.userLevelUpModel.setValue(undefined);
                        this.myBuildingsPcs.complete(true);
                    }
                    this.buildingModel.userLevelUpModel.setValue(undefined);
                    this.topPanel.interactiveChildren = true;
                }
                break;
        }
    }

    protected override build(): void {
        const upgrades = this.buildingModel.upgrades;
        const lastUpgradedItemId = this.variableSaver.getString(`${this.buildingModel.id.value}lastupgradeditem,${this.guestModel.id.value}`);
        if (lastUpgradedItemId) {
            const foundIndex = upgrades.findIndex(upgrade => upgrade.id.value === lastUpgradedItemId);
            if (foundIndex !== -1 && upgrades[foundIndex].elements.value.needToUpgrade === 0) {
                this.selectedItemIndex = upgrades.findIndex(upgrade => upgrade.elements.value.needToUpgrade > 0);
                if (this.selectedItemIndex === -1) {
                    this.selectedItemIndex = foundIndex;
                }
            } else {
                this.selectedItemIndex = Math.max(foundIndex, 0);
            }
        }
        if (this.buildingModel.needToFix.value) {
            const fixUpgrades = upgrades.filter((item) => item.elements.value.needToFix > 0 && item.lock.value.status == false);
            const selectedItem = fixUpgrades.reduce((previous, current) => previous.fixCostInCoins.value > current.fixCostInCoins.value ? previous : current);
            this.selectedItemIndex = upgrades.findIndex((item) => item.id.value === selectedItem.id.value);
        }
        this.upgradePanel = new UpgradePanel(this.commonResources, this.upgradeResources, this.buildingModel.upgrades[this.selectedItemIndex]);
        this.upgradePanel.onUpgradeButtonClick.add(this.upgradeButtonClickHandle, this);
        this.circleScroll = new UpgradeCircleScroll(375);
        this.buildingModel.upgrades.forEach((upgradeItemModel, index) => {
            const upgradeElement = upgradeItemModel.elements.value;
            const item = new BuildingItem(this.myBuildingsDynamicResources.resource(upgradeItemModel.imageUrl.value), this.upgradeResources, upgradeItemModel);
            item.updateCurrentState();
            item.current = index === this.selectedItemIndex;
            const progressPoints = upgradeElement.needToFix > 0 ? upgradeElement.needToFix : upgradeElement.upgraded;
            item.updateItemsNumber(progressPoints, upgradeElement.needToUpgrade + upgradeElement.upgraded + upgradeElement.needToFix);
            const onClickItemListener = () => this.upgradeItemClickHandle(index);
            item.onClick.add(onClickItemListener);
            this.itemsListeners.push(onClickItemListener);
            this.upgradeItems.push(item);
        });
        this.circleScroll.addItem(...this.upgradeItems);
        this.upgradePanel.onRightButtonClick.add(this.onUpgradePanelRightButtonClick, this);
        this.upgradePanel.onLeftButtonClick.add(this.onUpgradePanelLeftButtonClick, this);
        this.addChild(this.circleScroll);
        this.addChild(this.building);
        this.addChild(this.upgradePanel);
        this.loyaltyCoinsContainer = new LoyaltyCoinsContainer(this.commonResources, this.buildingModel.piggyMultiplier.value);
        this.loyaltyCoinsContainer.eventMode = "static";
        this.loyaltyCoinsContainer.on("pointerdown", this.showPiggyInfoTooltip, this);
        this.loyaltyCoinsContainer.visible = this.buildingModel.piggyMultiplier.value != 1;
        this.addChild(this.loyaltyCoinsContainer);
        this.bottomLight = new Sprite(this.upgradeResources.assets_views_upgrade_building_frame_light_png);
        this.addChild(this.bottomLight);
        this.backButton = new DefaultButton(this.commonResources.assets_common_ui_back_png);
        this.backButton.hitArea = new Rectangle(-this.backButton.width * 0.65, -this.backButton.height * 0.65, this.backButton.width * 2.5, this.backButton.height * 1.75);
        this.backButton.onUp.add(this.backButtonClickHandle, this);
        this.addChild(this.backButton);
        this.backToLobbyButton = new ButtonWithScaleAnimation(this.upgradeResources.assets_views_upgrade_button_back_to_lobby_png);
        this.backToLobbyButton.hitArea = new Rectangle(0, this.backToLobbyButton.width * 0.2, this.backToLobbyButton.width, this.backToLobbyButton.height * 0.75);
        this.backToLobbyButton.onUp.add(this.backToLobbyButtonClickHandle, this);
        this.addChild(this.backToLobbyButton);
        if (this.isFirstShow && this.tutorialResources) {
            this.fadeScreen = new FadeScreen(0.3, 0, 0.8, this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
            this.addChild(this.fadeScreen);
            this.upgradeTutorial = new UpgradeTutorial(this.tutorialResources, this.commonResources, this.soundResources);
            this.addChild(this.upgradeTutorial);
            this.tutorialInputBlocker = new InputBlocker();
            this.addChild(this.tutorialInputBlocker);
        }
        this.inputBlocker = new InputBlocker();
        this.addChild(this.inputBlocker);
        this.coinsSubtractPoint = new Point();
        this.tokensSubtractPoint = new Point();
        this.coinsSubtractAnimation = new CoinsCollectAnimationView(this.commonResources, 15, this.coinsSubtractPoint);
        this.tokensSubtractAnimation = new CoinsCollectAnimationView(this.commonResources, 15, this.tokensSubtractPoint, false);
        this.addChild(this.coinsSubtractAnimation);
        this.addChild(this.tokensSubtractAnimation);
        if (this.neededTokenTutorial) {
            this.tokenTutorial = new UpgradeTutorialForToken(this.upgradeResources, this.commonResources, this.soundResources);
            this.fadeScreen = new FadeScreen(0.3, 0, 0.8, this.canvasScaler.referenceWidth, this.canvasScaler.referenceHeight);
            this.tutorialInputBlocker = new InputBlocker();
            this.tutorialInputBlocker.blocked = true;
            this.tutorialInputBlocker.on('pointerup', this.onTutorialInputBlockerClickHandle, this);
            this.addChild(this.fadeScreen, this.tutorialInputBlocker, this.tokenTutorial);
        }
        super.build();
    }

    private async onUpgradePanelRightButtonClick(): Promise<void> {
        this.inputBlocker.blocked = true;
        this.soundResources.assets_sounds_myBuildings_upgrade_click_mp3.play();
        const itemToScroll = this.circleScroll.itemIndex + 1 === this.circleScroll.scrollItems.length ? 0 : this.circleScroll.itemIndex + 1;
        this.updatePanelAndItems(itemToScroll);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.play();
        await this.circleScroll.showScrollToAnimation(itemToScroll);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.stop();
        this.inputBlocker.blocked = false;
    }

    private async onUpgradePanelLeftButtonClick(): Promise<void> {
        this.inputBlocker.blocked = true;
        this.soundResources.assets_sounds_myBuildings_upgrade_click_mp3.play();
        const itemToScroll = this.circleScroll.itemIndex === 0 ? this.circleScroll.scrollItems.length - 1 : this.circleScroll.itemIndex - 1;
        this.updatePanelAndItems(itemToScroll);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.play();
        await this.circleScroll.showScrollToAnimation(itemToScroll);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.stop();
        this.inputBlocker.blocked = false;
    }

    private async upgradeItemClickHandle(index: number): Promise<void> {
        if (this.circleScroll.itemIndex === index) {
            return;
        }
        this.inputBlocker.blocked = true;
        this.soundResources.assets_sounds_myBuildings_upgrade_click_mp3.play();
        this.updatePanelAndItems(index);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.play();
        await this.circleScroll.showScrollToAnimation(index);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.stop();
        this.inputBlocker.blocked = false;
    }

    private updatePanelAndItems(index: number, fromUpgradeOrFix: boolean = false): void {
        this.upgradeItems.forEach((item: BuildingItem, itemIndex: number) => {
            const upgradeModel = this.buildingModel.upgrades[itemIndex];
            item.updateCurrentState();
            item.current = itemIndex === index;
            const elementData = upgradeModel.elements.value;
            const progressPoints = elementData.needToFix > 0 ? elementData.needToFix : elementData.upgraded;
            item.updateItemsNumber(progressPoints, elementData.needToUpgrade + elementData.upgraded + elementData.needToFix);
        });
        this.upgradePanel.updateResourcePanel(this.buildingModel.upgrades[index], fromUpgradeOrFix);
    }

    private async show(): Promise<void> {
        this.soundResources.assets_sounds_myBuildings_upgrade_zoom_in_mp3.play();
        let scrollShowAnimation: Promise<void> = null;

        this.inputBlocker.blocked = true;
        this.transitionTimeLine = new gsap.core.Timeline({ paused: true });
        this.backButton.eventMode = "none";
        this.transitionTimeLine.to(this.building, { y: this.building.y - 150, duration: 1 });
        this.transitionTimeLine.fromTo(this.upgradePanel, { alpha: 0, y: this.upgradePanel.position.y + 500 }, { alpha: 1, y: this.upgradePanel.position.y, duration: 0.8 }, "<");
        this.transitionTimeLine.fromTo(
            this.loyaltyCoinsContainer,
            {
                y: this.loyaltyCoinsContainer.position.y + 500
            }, {
            y: this.loyaltyCoinsContainer.position.y, duration: 0.8,
            onComplete: () => this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.play()
        }, "<");
        this.transitionTimeLine.fromTo(this.backToLobbyButton, { alpha: 0 }, { alpha: 1, duration: 0.6 }, "<");
        this.transitionTimeLine.fromTo(this.circleScroll.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 1 }, "<");
        this.transitionTimeLine.fromTo(this.circleScroll, { y: this.circleScroll.position.y + 800 }, { y: this.circleScroll.position.y, duration: 0.8 }, "<");
        this.transitionTimeLine.call(() => {
            if (!this.hideFlag) {
                scrollShowAnimation = this.circleScroll.showFullScrollAnimation(-1, this.selectedItemIndex);
            }
        }, null, "<");
        this.transitionTimeLine.fromTo(this.bottomLight, { alpha: 0 }, { alpha: 1, duration: 0.5 }, "<80%");
        await this.transitionTimeLine.play();
        await scrollShowAnimation;
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.stop();
        this.backButton.eventMode = "static";
        this.inputBlocker.blocked = false;

        if (this.isFirstShow && this.tutorialResources) {
            this.tutorialInputBlocker.blocked = true;
            const fadeScreenIndex = this.getChildIndex(this.fadeScreen);
            this.setChildIndex(this.tutorialInputBlocker, fadeScreenIndex);
            this.setChildIndex(this.upgradePanel, fadeScreenIndex + 1);
            this.setChildIndex(this.loyaltyCoinsContainer, fadeScreenIndex + 1);
            this.upgradePanel.blockArrows = true;
            this.fakeBuildingItem = this.createFakeBuildingItem();
            this.addChildAt(this.fakeBuildingItem, fadeScreenIndex + 1);
            this.fakeBuildingItem.position.set(344, 1110);
            this.fadeScreen.fadeIn();
            await this.upgradeTutorial.showFirstTutorial();
        }
        if (this.neededTokenTutorial) {
            this.tutorialInputBlocker.blocked = true;
            const inputBlockerIndex = this.getChildIndex(this.tutorialInputBlocker);
            this.setChildIndex(this.loyaltyCoinsContainer, inputBlockerIndex);
            this.setChildIndex(this.upgradePanel, inputBlockerIndex);
            this.upgradePanel.blockArrows = true;
            this.fakeBuildingItem = this.createFakeBuildingItem();
            this.addChildAt(this.fakeBuildingItem, inputBlockerIndex);
            this.fakeBuildingItem.position.set(340, 1109);
            this.fadeScreen.fadeIn();
            await this.tokenTutorial.showTutorial();
        }
    }

    private createFakeBuildingItem(): BuildingItem {
        const currentScrollItem = this.circleScroll.scrollItems[this.circleScroll.itemIndex] as BuildingItem;
        const buildingItemTexture = (currentScrollItem.getChildAt(0) as Sprite).texture;
        const fakeBuildingItem = new BuildingItem(buildingItemTexture, this.upgradeResources, currentScrollItem.upgradeModel);
        fakeBuildingItem.hideText();
        return fakeBuildingItem;
    }

    private async hide(): Promise<void> {
        this.hideFlag = true;
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.play();
        this.circleScroll.showFullScrollAnimation(1);
        await TickerDelay.delay(500);
        this.soundResources.assets_sounds_myBuildings_upgrade_zoom_out_mp3.play();
        await Promise.all([this.building.showDefaultStyle(), this.transitionTimeLine.reverse()]);
        this.soundResources.assets_sounds_myBuildings_upgrade_scrolling_mp3.stop();
    }

    private async upgradeButtonClickHandle(upgradeItemModel: IUpgradeBuildingModel, perCoins: boolean): Promise<void> {
        this.inputBlocker.blocked = true;
        this.piggyTooltipInfo?.hideHint();
        this.soundResources.assets_sounds_upgrade_card_select_upgrade_mp3.play();
        try {
            this.onTutorialInputBlockerClickHandle();
            if (this.outOfCoins(upgradeItemModel, perCoins)) {
                await this.showOutOfCoinsPanel(perCoins);
                this.inputBlocker.blocked = false;
                return;
            }
            this.upgradeCompletionSource = new PromiseCompletionSource<void>();
            let clickResult: FixResult | UpgradeResult;
            this.variableSaver.saveString(`${this.buildingModel.id.value}lastupgradeditem,${this.guestModel.id.value}`, upgradeItemModel.id.value);
            this.topPanel.interactiveChildren = false;
            if (upgradeItemModel.elements.value.needToFix > 0) {
                clickResult = await this.myBuildingController.fixClickHandle(this.buildingModel, upgradeItemModel.id.value, perCoins);
            } else {
                clickResult = await this.myBuildingController.upgradeClickHandle(this.buildingModel, upgradeItemModel.id.value, perCoins);
            }
            this.playCubesParticleAnimation(perCoins);
            if (this.isFirstShow && this.tutorialResources) {
                await this.firstTimeExperienceController.sendShownTooltip({ tooltips: { upgradeIntro: false } });
                await this.firstTimeExperienceController.getFirstTimeExperience();
                await this.showUpgradeWithTutorial(upgradeItemModel, perCoins);
            }
            else {
                this.soundResources.assets_sounds_myBuildings_upgrade_xp_amount_appear_mp3.play();
                this.soundResources.assets_sounds_upgrade_coin_win_card_highlight_mp3.play();
                await Promise.all([
                    perCoins ? this.coinsSubtractAnimation.startAnimation() : this.tokensSubtractAnimation.startAnimation(),
                    this.upgradePanel.makeUpgradeOrFix()
                ]);
                this.updatePanelAndItems(this.circleScroll.itemIndex, true);
                await this.updateExperienceWithAnimation(upgradeItemModel.upgradePoints.value);

                let formattedTokenAmount: string;
                const tokenAmount = parseFloat(clickResult.currentGuestRewardInTokens);
                if (Number.isInteger(tokenAmount)) {
                    formattedTokenAmount = StringFormatExtention.formatWithComma(tokenAmount.toString());
                } else {
                    const fixedTokenAmount = tokenAmount.toFixed(4);
                    formattedTokenAmount = StringFormatExtention.formatWithComma(parseFloat(fixedTokenAmount).toString());
                }
                await this.playTokenForPiggyAnimation(formattedTokenAmount);

                this.topPanel.bringToOriginParent();
                if (clickResult instanceof UpgradeResult && this.isFirstShow) {
                    await this.myBuildingController.showBuildingUpgradeItemPopup(this.buildingModel, this.cancellationToken);
                }
                this.topPanel.bringToFront();
            }
        } catch (error) {
            this.logger.error(error);
            if (error.response?.status === 400 || error.response?.data?.statusCode == 400) {
                this.cancellationToken.cancel();
            }
        }
        finally {
            this.upgradeCompletionSource?.complete();
            this.inputBlocker.blocked = false;
            this.topPanel.interactiveChildren = true;
        }
    }

    private async playCubesParticleAnimation(perCoins: boolean): Promise<void> {
        const textures = new CubeTexturePack(this.upgradeResources);
        const particleAnimation = new CubeExplowAnimationView(textures.randomCubes);
        particleAnimation.scale.set(1.2);
        const positionX = this.upgradePanel.position.x + (perCoins ? this.upgradePanel.coinButtonPosition.x : this.upgradePanel.tokenButtonPosition.x) - 115;
        particleAnimation.position.set(positionX, this.upgradePanel.position.y + this.upgradePanel.height * 0.33);
        this.addChild(particleAnimation);
        await particleAnimation.play();
        particleAnimation.stop();
        particleAnimation.destroy();
    }

    private async playTokenForPiggyAnimation(tokenCount: string): Promise<void> {
        const tokenReward = new HBox(10);
        const tokenIcon = new Sprite(this.commonResources.assets_common_ui_top_panel_token_icon_png);
        tokenReward.addChild(tokenIcon);
        const tokensCount = new Text(tokenCount, new ExperienceTextStyle());
        tokenReward.addChild(tokensCount);
        tokensCount.position.y = 7;
        tokenReward.pivot.set(tokenIcon.width * 0.5, tokenIcon.height * 0.5);
        const timeline = gsap.timeline();

        const piggyIcon = new Sprite(this.commonResources.assets_common_ui_piggy_piggy_icon_png);
        piggyIcon.pivot.set(piggyIcon.width * 0.5, piggyIcon.height * 0.5);
        piggyIcon.position.set(11 + piggyIcon.width * 0.5, this.topPanel.position.y + this.topPanel.height + 30 + piggyIcon.height * 0.5);
        this.addChild(piggyIcon);

        timeline.fromTo(piggyIcon.scale, { x: 0, y: 0 }, { x: 1, y: 1, duration: 0.6, ease: "back.out(3)" });
        timeline.fromTo(tokenReward,
            {
                x: this.upgradePanel.x + this.upgradePanel.width * 0.13,
                y: this.upgradePanel.y + this.upgradePanel.height * 0.5
            },
            {
                x: this.canvasScaler.referenceWidth * 0.11,
                y: this.canvasScaler.referenceHeight * 0.4,
                onStart: () => {
                    this.backButton.visible = false;
                    this.addChild(tokenReward);
                },
                duration: 0.8
            }, "<");
        timeline.fromTo(tokenReward.scale,
            {
                x: 0.3,
                y: 0.3
            },
            {
                x: 1.5,
                y: 1.5,
                duration: 0.5
            }, "<");

        timeline.to(tokenReward,
            {
                y: this.topPanel.y + 220,
                duration: 0.6,
                delay: 0.6,
            }, ">");
        timeline.to(tokenReward.scale,
            {
                x: 0.3,
                y: 0.3,
                onComplete: () => {
                    tokenReward.visible = false;
                },
                duration: 0.8
            }, "<");
        timeline.to(piggyIcon.scale, {
            x: 0,
            y: 0,
            duration: 0.5,
            onComplete: () => {
                this.backButton.visible = true;
            },
            ease: "back.in(3)"
        });
        await timeline.play();
        timeline.kill();
        tokenReward.destroy();
        piggyIcon.destroy();
    }

    private async showUpgradeWithTutorial(upgradeItemModel: IUpgradeBuildingModel, perCoins: boolean): Promise<void> {
        this.swapChildren(this.tutorialInputBlocker, this.fadeScreen);
        this.swapChildren(this.tutorialInputBlocker, this.upgradePanel);
        this.setChildIndex(this.inputBlocker, this.children.length - 1);
        this.fadeScreen.fadeOut();
        this.upgradePanel.blockArrows = false;
        await Promise.all([
            this.soundResources.assets_sounds_upgrade_coin_win_card_highlight_mp3.play(),
            perCoins ? this.coinsSubtractAnimation.startAnimation() : this.tokensSubtractAnimation.startAnimation(),
            this.upgradeTutorial.hideFirstTutorial(),
            this.upgradePanel.makeUpgradeOrFix()
        ]);
        this.updatePanelAndItems(this.circleScroll.itemIndex, true);
        this.removeChild(this.fakeBuildingItem);
        await this.updateExperienceWithAnimation(upgradeItemModel.upgradePoints.value);
        await this.showSecondTutorial();
        if (this.buildingModel.piggyMultiplier.value != 1) {
            await this.showThirdTutorial();
        }
        this.isFirstShow = false;
        this.topPanel.bringToOriginParent();
        await this.myBuildingController.showBuildingUpgradeItemPopup(this.buildingModel, this.cancellationToken);
        this.myBuildingsPcs.complete(false);
        this.topPanel.bringToFront();
        this.tutorialInputBlocker.blocked = false;
    }

    private async backButtonClickHandle(): Promise<void> {
        this.backButton.eventMode = "none";
        this.backToLobbyButton.eventMode = "none";
        this.building.enabledButtons = false;
        this.soundResources.assets_sounds_myBuildings_upgrade_X_button_click_mp3.play();
        this.piggyTooltipInfo?.hideHint();
        await this.hide();
        this.pageCompletionSource.complete();
    }

    private async backToLobbyButtonClickHandle(): Promise<void> {
        this.analyticsProvider.registerGoogleEvent(new VirtualScreenEvent("Click on back to lobby icon", this.analyticsProvider.currentEventIndex));
        this.backButton.eventMode = "none";
        this.backToLobbyButton.eventMode = "none";
        this.building.enabledButtons = false;
        this.soundResources.assets_sounds_myBuildings_upgrade_X_button_click_mp3.play();
        this.piggyTooltipInfo?.hideHint();
        await TickerDelay.delay(100);
        this.myBuildingsPcs.complete(false);
    }

    private outOfCoins(upgradeItemModel: IUpgradeBuildingModel, perCoins: boolean): boolean {
        if (perCoins) {
            const cost = upgradeItemModel.elements.value.needToFix > 0 ? upgradeItemModel.fixCostInCoins.value : upgradeItemModel.upgradeCostInCoins.value;
            return this.playerModel.coins.value < cost;
        } else {
            const cost = upgradeItemModel.elements.value.needToFix > 0 ? upgradeItemModel.fixCostInTokens.value : upgradeItemModel.upgradeCostInTokens.value;
            return new Big(this.playerModel.tokens.value ?? 0).lt(cost);
        }
    }

    private async showOutOfCoinsPanel(perCoins: boolean): Promise<void> {
        const outOfCoinsHideCS = new PromiseCompletionSource<void>();
        const outOfCoinsPanel = new OutOfCoinsPanel(this.commonResources, this.upgradeResources, perCoins);
        outOfCoinsPanel.pivot.set(outOfCoinsPanel.getLocalBounds().width * 0.5, outOfCoinsPanel.getLocalBounds().height * 0.5);
        outOfCoinsPanel.position.set(407, 1376);
        outOfCoinsPanel.onCloseButtonClick.once(async () => {
            await outOfCoinsPanel.hide();
            outOfCoinsHideCS?.complete();
        });
        TickerDelay.delayCallback(async () => {
            await outOfCoinsPanel.hide();
            outOfCoinsHideCS?.complete();
        }, 2000);
        this.addChild(outOfCoinsPanel);
        outOfCoinsPanel.show();
        await outOfCoinsHideCS.result;
        outOfCoinsPanel.destroy();
    }

    private async showSecondTutorial(): Promise<void> {
        const buildingProgress = this.building.buildingProgress;
        const buildingProgressPosition = buildingProgress.position.clone();
        this.addChild(buildingProgress);
        const fadeScreenIndex = this.getChildIndex(this.fadeScreen);
        this.setChildIndex(buildingProgress, fadeScreenIndex + 1);
        this.setChildIndex(this.upgradePanel, fadeScreenIndex - 1);
        this.setChildIndex(this.loyaltyCoinsContainer, fadeScreenIndex - 1);
        this.setChildIndex(this.tutorialInputBlocker, fadeScreenIndex - 1);
        buildingProgress.position.set(170, 258);
        this.fadeScreen.fadeIn();
        await this.upgradeTutorial.showSecondTutorial();
        await TickerDelay.delay(3000);
        this.fadeScreen.fadeOut();
        await this.upgradeTutorial.hideSecondTutorial();
        this.building.addChildAt(buildingProgress, 0);
        buildingProgress.position.set(buildingProgressPosition.x, buildingProgressPosition.y);
    }

    private async showThirdTutorial(): Promise<void> {
        await this.upgradeTutorial.showThirdTutorial();
        await TickerDelay.delay(3000);
        await this.upgradeTutorial.hideThirdTutorial();
    }

    private async updateExperienceWithAnimation(xpValue: number): Promise<void> {
        const experienceText = new Text(` ${StringFormatExtention.formatWithComma(xpValue)} XP `, new ExperienceTextStyle());
        experienceText.updateText(true);
        const rayContainer = new RayLightContainer(this.canvasScaler, experienceText.texture);
        rayContainer.pivot.set(rayContainer.width * 0.5, rayContainer.height * 0.5);
        experienceText.scale.set(0);
        rayContainer.lightLength = 0.8;

        const timeline = gsap.timeline();
        timeline.fromTo(rayContainer,
            {
                x: this.upgradePanel.x + this.upgradePanel.width * 0.15,
                y: this.upgradePanel.y + this.upgradePanel.height * 0.8
            },
            {
                x: this.canvasScaler.referenceWidth * 0.5,
                y: this.canvasScaler.referenceHeight * 0.5,
                onStart: () => {
                    this.addChild(rayContainer);
                    this.soundResources.assets_sounds_myBuildings_upgrade_player_card_comes_in_mp3.play();
                },
                duration: 0.8
            });
        timeline.fromTo(rayContainer, { lightY: -5 }, { lightY: 0, duration: 0.8 }, "<");
        timeline.fromTo(rayContainer.scale,
            {
                x: 0,
                y: 0
            },
            {
                x: 1,
                y: 1,
                duration: 0.5
            }, "<");

        timeline.to(rayContainer,
            {
                y: this.canvasScaler.referenceHeight * 0.15,
                duration: 0.6,
                delay: 0.6,
                onStart: () => {
                    this.soundResources.assets_sounds_myBuildings_upgrade_click_of_coins_mp3.play();
                },
                onComplete: () => {
                    this.building.buildingProgressUpdate();
                    this.soundResources.assets_sounds_myBuildings_upgrade_xp_amount_gain_mp3.play();
                }
            }, ">");
        timeline.fromTo(rayContainer, { lightY: 0 }, { lightY: 4, duration: 0.8, ease: "power2.out" }, "<");
        timeline.fromTo(rayContainer.scale,
            {
                x: 1,
                y: 1
            },
            {
                x: 0,
                y: 0,
                duration: 0.8
            }, "<");
        await timeline.play();
        timeline.kill();
        experienceText.destroy();
        rayContainer.destroy();
    }

    private async onTutorialInputBlockerClickHandle(): Promise<void> {
        if (this.neededTokenTutorial) {
            await Promise.all([
                this.firstTimeExperienceController.sendShownTooltip({ tooltips: { firstUpgradeByTokens: false } }),
                this.tokenTutorial.hideTutorial(),
                this.fadeScreen.fadeOut()
            ]);
            this.neededTokenTutorial = false;
            this.firstTimeExperienceController.getFirstTimeExperience();
            this.removeChild(this.fakeBuildingItem);
            this.tutorialInputBlocker.blocked = false;
            this.upgradePanel.blockArrows = false;
            this.setChildIndex(this.inputBlocker, this.children.length - 1);
        }
    }

    private async showPiggyInfoTooltip(): Promise<void> {
        await this.piggyTooltipInfo?.hideHint();
        this.piggyTooltipInfo = new FullBuildingTooltip(this.commonResources);
        this.piggyTooltipInfo.position.set(this.loyaltyCoinsContainer.x + this.loyaltyCoinsContainer.width * 0.5, this.loyaltyCoinsContainer.y - 120);
        this.addChild(this.piggyTooltipInfo);
        this.piggyTooltipInfo.changeTooltipTextColor("#ffc700");
        this.piggyTooltipInfo.showHint("PIGGY BOOSTER,\nEXCLUSIVE TO BUILDING OWNERS", 6);
    }

    protected override layout(width: number, height: number): void {
        this.circleScroll.position.set(width * 0.5 - 5, 360);
        this.backButton.position.set(74, 263 - this.backButton.height * 0.5);
        this.backToLobbyButton.position.set(-6, 285);
        this.upgradePanel.position.set(35, 1275);
        this.loyaltyCoinsContainer.position.set(width * 0.5 - this.loyaltyCoinsContainer.width * 0.5, 1680);
        this.bottomLight.position.set(width * 0.5 - this.bottomLight.width * 0.5, 1645);
        this.inputBlocker.width = width;
        this.inputBlocker.height = height;
        this.coinsSubtractPoint.set(-300, 2000);
        this.tokensSubtractPoint.set(-700, 2000);
        this.coinsSubtractAnimation.position.set(width * 0.45, 0);
        this.coinsSubtractAnimation.scale.set(0.7);
        this.tokensSubtractAnimation.position.set(width * 0.8, 0);
        this.tokensSubtractAnimation.scale.set(0.7);
        if (this.isFirstShow && this.tutorialResources) {
            this.tutorialInputBlocker.width = width;
            this.tutorialInputBlocker.height = height;
        }
        if (this.neededTokenTutorial) {
            this.tutorialInputBlocker.width = width;
            this.tutorialInputBlocker.height = height;
        }
        super.layout(width, height);
    }

    public destroy(options?: boolean | IDestroyOptions): void {
        this.upgradePanel.onRightButtonClick.remove(this.onUpgradePanelRightButtonClick, this);
        this.upgradePanel.onLeftButtonClick.remove(this.onUpgradePanelLeftButtonClick, this);
        this.backButton.onUp.remove(this.backButtonClickHandle, this);
        this.backToLobbyButton.onUp.remove(this.backToLobbyButtonClickHandle, this);
        this.buildingModel.propertyChanged.remove(this.onBuildingModelPropertyChanged, this);
        this.itemsListeners.forEach((listener, index) => this.upgradeItems[index].onClick.remove(listener));
        this.upgradePanel.onUpgradeButtonClick.remove(this.upgradeButtonClickHandle, this);
        if (this.neededTokenTutorial) {
            this.tutorialInputBlocker.off('pointerup', this.onTutorialInputBlockerClickHandle, this);
        }
        this.loyaltyCoinsContainer.off("pointerdown", this.showPiggyInfoTooltip, this);
        this.transitionTimeLine?.kill();
        super.destroy(options);
    }
}

class ExperienceTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 60,
            fill: 0xffffff
        }));
    }
}
